import * as React from "react";
import {Radio} from "./Radio";

export class BooleanRadios extends React.Component<any> {
    render() {
        const {name, trueLabel, falseLabel, value, onChange, inline = true} = this.props;

        return (
            <>
                <Radio
                    name={name}
                    id={name + 'true'}
                    value={value}
                    onChange={() => onChange(true)}
                    inputLabel={trueLabel}
                    inline={inline}
                />
                <Radio
                    name={name}
                    id={name + 'false'}
                    value={!value}
                    onChange={() => onChange(false)}
                    inputLabel={falseLabel}
                    inline={inline}
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/BooleanRadios.tsx